<template>
  <div class="servicesWrap">
    <div class="profile-card" style="background: linear-gradient(to bottom, #ffe9c9, #fd8c4f);">
      <div class="profile-header">
        <div class="avatar"><img src="https://h5.tc-rescue.com/snServices/images/icon_touxiang.png"></div>
        <div class="user-info">
          <h2>壳牌鹏致（园洲镇鑫宝驾）</h2>
          <p>13652***1253</p>
          <p>园洲镇沙河大道69号</p>
        </div>
      </div>
      <div class="stats">
        <div class="stat-item"><div class="stat-value">52单</div><div class="stat-label">洗车</div></div>
        <div class="stat-item"><div class="stat-value">211单</div><div class="stat-label">保养</div></div>
        <div class="stat-item"><div class="stat-value">13单</div><div class="stat-label">代驾</div></div>
        <div class="stat-item"><div class="stat-value">50单</div><div class="stat-label">玻璃修复</div></div>
      </div>
    </div>
    <van-tabs :active="tabsOn" bind:change="onChange">
      <van-tab title="我的订单">
        <div class="list-item" v-for="(item,index) in orderList">
          <img src="https://h5.tc-rescue.com/snServices/images/icon_order.png" class="item-image">
          <div class="item-content">
            <div class="item-title">{{item.user_nick}} - {{item.user_phone}}</div>
            <div class="item-desc">{{serviceName[item.service_type]}}</div>
            <div class="item-meta">预约时间: {{item.json_data?item.json_data.bookDate:''}}</div>
          </div>
<!--          <button class="item-button"></button>-->
          <van-icon name="notes-o" @click="showDetail(item)" color="#fd802a"  size="25px" style="margin-right: 10px;" />
          <button class="item-button" @click="showFinish(item)">核销</button>
        </div>
      </van-tab>
      <van-tab title="过往订单">
        <div class="list-item" v-for="(item,index) in orderFinishList">
          <img src="https://h5.tc-rescue.com/snServices/images/icon_order.png" class="item-image">
          <div class="item-content">
            <div class="item-title">{{item.user_nick}} - {{item.user_phone}}</div>
            <div class="item-desc">{{serviceName[item.service_type]}}</div>
            <div class="item-meta">预约时间: {{item.json_data?item.json_data.bookDate:''}}</div>
          </div>
          <van-icon name="notes-o" @click="showDetail(item)" color="#fd802a"  size="25px" style="margin-right: 10px;" />
        </div>
        <p v-if="orderFinishList.length<=0" class="noData">暂无数据</p>
      </van-tab>
    </van-tabs>
    <van-popup  v-model:show="showConfirm" bind:close="()=>{showConfirm = false}">
      <div class="orderFinishWrap">
        <van-form @submit="onSubmit">
          <van-field v-model="orderCode" label="订单核销码"  placeholder="请输入订单核销码" />
          <van-button class="orderFinishBtn" :loading="submitLoading" size="small" round block type="info" native-type="submit">提交</van-button>
        </van-form>
      </div>
    </van-popup>
    <van-popup  v-model:show="showDetailView" bind:close="()=>{showDetailView = false}">
      <div class="orderInfoWrap">
        <van-cell title-width="40" v-for="(item,index) in orderOn.json_data" :title="jsonKeyName[index]?jsonKeyName[index]:'-'" :value="item" border/>
      </div>
    </van-popup>
  </div>
</template>

<script>
import util from '@/utils';
import Data from '@/utils/data';
import {isWeiXin, isSafari} from '@/utils';
import { servicesEdit, servicesList} from "@/apis/rescue";


export default {
  data() {
    return {
      active: "",
      tabsOn: "我的预约",
      merchant_id: "bsa0909",
      showConfirm: false,
      showDetailView: false,
      serviceName:{
        1: "车辆安全服务",
        2: "洗车服务",
        3: "油漆修复",
        4: "代驾服务",
        5: "维修保养服务",
      },
      orderOn:{},
      jsonKeyName:{
        'phone' : '手机号',
        'carMark' : '车牌',
        'carNo' : '车架号',
        'currentKM' : '当前公里数',
        'beforeKM' : '之前公里数',
        'bookDate' : '预约时间',
        'currentDate' : '当前时间',
        'remark' : '情况说明',
      },
      orderList:[
        {type: "洗车", userPhone: "", userName: "" },
        {type: "洗车", userPhone: "", userName: "" },
        {type: "洗车", userPhone: "", userName: "" },
        {type: "洗车", userPhone: "", userName: "" },
        {type: "洗车", userPhone: "", userName: "" },
      ],
      orderFinishList:[

      ],
      submitLoading: false,
      orderCode: ""
    }
  },
  created() {
    this.merchant_id = this.$route.query.id;
    this.getList();
  },
  mounted() {

  },
  methods: {
    getList(){
      let data = {
        page: 1,
        limit: 100,
        merchant_id: this.merchant_id
      }
      this.orderList = [];
      this.orderFinishList = [];
      servicesList(data).then((res)=>{
        let resData = res.data.data;
        if(res.code == 1){
          resData.data.forEach((item,index)=>{
            if(item.status == 0){
              this.orderList.push(item);
            }else{
              this.orderFinishList.push(item);
            }
          });
        }else if (res.data.code == 1){
          resData.data.data.forEach((item,index)=>{
            if(item.status == 0){
              this.orderList.push(item);
            }else{
              this.orderFinishList.push(item);
            }
          });
        }else{
          this.$toast(res.data.info? res.data.info:'系统错误');
        }
      })
    },
    showDetail(row){
      this.orderOn = row;
      this.showDetailView = true;
    },
    showFinish(row){
      this.orderOn = row;
      this.showConfirm = true;
      this.orderCode = "";
    },
    onSubmit() {
      let that = this;
      let data = {
        merchant_id: this.merchant_id,
        order_id: this.orderOn.order_id,
        status: 1
      }
      console.log(data)
      if (!this.orderCode) {
        this.$toast('请输入订单核销码');
        return
      }
      this.submitLoading = true;
      servicesEdit(data).then((res) => {
        this.submitLoading = false;
        console.log(res)
        if(res.data.code == 1){
          this.$toast('核销成功');
          this.showConfirm = false;
          this.getList();
        }else{
          this.$toast(res.info?res.info:'核销失败');
        }
      })
    },
    onClose() {
      this.showConfirm = false;
    },
    onConfirm(row) {
      this.form.battery_date = row.text;
      this.showPicker = false;
    }
  }
}
</script>

<style lang='scss' scoped>
.orderFinishWrap{
  padding: 30px 10px 0;
  text-align: center;
  width: 300px;
}
.orderFinishBtn{
  width: 100px;
  margin: 40px auto 20px;
}
.orderInfoWrap{
  padding: 5px;
  width: 300px;
}
.item-image{
  width: 50px;
  height: 50px;
}
.stat-label{
  color: #fff2ec;
}
</style>
